import axios from "axios";
import { get } from "lodash";
import moment from "moment";
import { BASE_URL } from "../../../consts/app.consts";
const curr_year = moment().year()

const InternalConsultantLecInvolConfig = {
    searchApi: "xceed.api.report.resource_person.internal_consultant_lecture_involvement_report",
    excelFileName: "internal-consultant-lecture-involvement-report",
    title: "Internal Consultant Lecture Involvement Report",
    sections: [
        {
            selectionTitle: "Filters",
            grid: { base: 1, md: 2, lg: 4, xl: 4 },
            filters: [
                {
                    label: "Year",
                    key: "year",
                    type: "drop-down",
                    options: Array.from({ length: 6 }, (_, i) => ({
                        label: String(curr_year - 3 + i),
                        value: curr_year - 3 + i
                    })).reverse()
                },
                {
                    label: "Month",
                    key: "month",
                    type: "drop-down",
                    options: moment.months().map((month, index) => ({
                        label: month,
                        value: index + 1
                    })),
                },
            ],
        },
    ],

    tableConfig: {
        column: [
            {
                header: "S/No",
                accessor: "row_number",
                width: 100,
            },
            {
                header: "Name of Consultant ",
                accessor: "resource_person_title",
                width: 400,
            },
            {
                header: "Non Fee Levying (NFL) Actual Lecture Hours Covered",
                accessor: "lecture_hours",
            }
        ],
    },
    actions: [
        {
            text: "Export to Excel",
            onClick: async (filter: any, data: any, setLoading: any) => {
                setLoading(true);
                try {
                    let response = await axios.post(
                        `${BASE_URL}/method/xceed.api.export_excel.resource_person.export_internal_consultant_lecture_involvement_report`,
                        { filter },
                        {
                            withCredentials: true,
                            responseType: "blob",
                        }
                    );
                    if (response) {
                        const href = URL.createObjectURL(response.data);
                        const link = document.createElement("a");
                        link.href = href;
                        link.setAttribute("download", `internal_consultant_lecture_involvement_report-${get(filter, 'month')}-${get(filter, 'year')}.xlsx`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(href);
                    }
                    setLoading(false);
                } catch (error: any) {
                    setLoading(false);
                    const newError: any = new Error("Unable to Generate Excel file");
                    newError.title = "Error";
                    newError.status = "error";
                    throw newError;
                }
            },
            buttonVariant: "solid",
            buttonColorScheme: "teal",
        }
    ],
};

export default InternalConsultantLecInvolConfig;